import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

// Tarjeta de acción condicional del dashboard (negocios y admin).
// Cada tono incluye su variante dark; el contenido usa tokens.
export const ACTION_TONES = {
  pink: {
    box: 'bg-pink-50 dark:bg-pink-500/10 border-pink-200 dark:border-pink-500/30',
    icon: 'text-pink-500 dark:text-pink-400',
    btn: 'text-pink-700 dark:text-pink-300 border-pink-300 dark:border-pink-500/40 hover:bg-pink-100 dark:hover:bg-pink-500/20',
  },
  amber: {
    box: 'bg-amber-50 dark:bg-amber-500/10 border-amber-200 dark:border-amber-500/30',
    icon: 'text-amber-500 dark:text-amber-400',
    btn: 'text-amber-700 dark:text-amber-300 border-amber-300 dark:border-amber-500/40 hover:bg-amber-100 dark:hover:bg-amber-500/20',
  },
  orange: {
    box: 'bg-orange-50 dark:bg-orange-500/10 border-orange-200 dark:border-orange-500/30',
    icon: 'text-orange-500 dark:text-orange-400',
    btn: 'text-orange-700 dark:text-orange-300 border-orange-300 dark:border-orange-500/40 hover:bg-orange-100 dark:hover:bg-orange-500/20',
  },
  red: {
    box: 'bg-red-50 dark:bg-red-500/10 border-red-200 dark:border-red-500/30',
    icon: 'text-red-500 dark:text-red-400',
    btn: 'text-red-700 dark:text-red-300 border-red-300 dark:border-red-500/40 hover:bg-red-100 dark:hover:bg-red-500/20',
  },
  yellow: {
    box: 'bg-yellow-50 dark:bg-yellow-500/10 border-yellow-200 dark:border-yellow-500/30',
    icon: 'text-yellow-600 dark:text-yellow-400',
    btn: 'text-yellow-700 dark:text-yellow-300 border-yellow-300 dark:border-yellow-500/40 hover:bg-yellow-100 dark:hover:bg-yellow-500/20',
  },
  purple: {
    box: 'bg-purple-50 dark:bg-purple-500/10 border-purple-200 dark:border-purple-500/30',
    icon: 'text-purple-500 dark:text-purple-400',
    btn: 'text-purple-700 dark:text-purple-300 border-purple-300 dark:border-purple-500/40 hover:bg-purple-100 dark:hover:bg-purple-500/20',
  },
  blue: {
    box: 'bg-blue-50 dark:bg-blue-500/10 border-blue-200 dark:border-blue-500/30',
    icon: 'text-blue-500 dark:text-blue-400',
    btn: 'text-blue-700 dark:text-blue-300 border-blue-300 dark:border-blue-500/40 hover:bg-blue-100 dark:hover:bg-blue-500/20',
  },
  green: {
    box: 'bg-green-50 dark:bg-green-500/10 border-green-200 dark:border-green-500/30',
    icon: 'text-green-600 dark:text-green-400',
    btn: 'text-green-700 dark:text-green-300 border-green-300 dark:border-green-500/40 hover:bg-green-100 dark:hover:bg-green-500/20',
  },
} as const;

export type ActionTone = keyof typeof ACTION_TONES;

const ActionCard: React.FC<{
  tone: ActionTone;
  icon: React.ReactNode;
  title: string;
  sub: string;
  cta: string;
  to: string;
}> = ({ tone, icon, title, sub, cta, to }) => {
  const navigate = useNavigate();
  const t = ACTION_TONES[tone];
  return (
    <div className={`flex items-center gap-3 border rounded-lg px-4 py-3 ${t.box}`}>
      <span className={`flex-shrink-0 ${t.icon}`}>{icon}</span>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-content">{title}</p>
        <p className="text-xs text-content-2 mt-0.5">{sub}</p>
      </div>
      <button
        type="button"
        onClick={() => navigate(to)}
        className={`flex-shrink-0 inline-flex items-center text-xs font-bold border rounded-md px-3 py-1.5 bg-surface transition-colors ${t.btn}`}
      >
        {cta}
        <ArrowRight className="ml-1 h-3 w-3" />
      </button>
    </div>
  );
};

export default ActionCard;
